<template>
  <layout-full>
    <div class="public-language-selector">
      <locale-selector />
    </div>
    <router-view />
  </layout-full>
</template>

<script>
import LayoutFull from '@core/layouts/layout-full/LayoutFull.vue'
import LocaleSelector from '@core/layouts/components/app-navbar/components/Locale.vue'

export default {
  components: {
    LocaleSelector,
    LayoutFull,
  },
}
</script>

<style lang="scss">
.public-language-selector {
  position: absolute;
  top: 1rem;
  right: 1rem;
  z-index: 1030;
}

@media (max-width: 575.98px) {
  .auth-wrapper.auth-v2 .auth-inner {
    padding-top: 4rem;
  }
}
</style>
